var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.34 0C12.68 0 0 12.68 0 28.34C0 44 12.68 56.68 28.34 56.68C44 56.68 56.68 44 56.68 28.34C56.83 12.68 44 0 28.34 0ZM38.89 25.36C38.8 25.36 38.72 25.35 38.63 25.35C36.98 25.35 35.64 26.69 35.64 28.34C35.64 29.99 36.98 31.33 38.63 31.33C38.72 31.33 38.81 31.33 38.89 31.32V43.85H17.79V31.31C19.27 31.13 20.43 29.87 20.43 28.34C20.43 26.81 19.28 25.55 17.79 25.37V12.84H38.89V25.37V25.36Z",
    fill: "#00ADEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardsIcon);
export default __webpack_public_path__ + "static/media/cards-icon.efb9293fa694aff50b6a82af58032341.svg";
export { ForwardRef as ReactComponent };